import {
  tableKeys,
  transportKeys,
  bucketKeys,
} from "@smart/bridge-resources-basic";
import { buildPermissionsDef } from "@smart/itops-constructs-basic";

import { apiGateway } from "./api-gateway";
import { snsSqsLambdas } from "./sns-sqs";

export const permissions = buildPermissionsDef(
  [
    ...apiGateway.lambdaKeys,
    ...snsSqsLambdas.lambdaKeys,
    "data-sync",
    "formVersion",
    "apiHealthCheck",
    "reminder-scanner",
  ],
  tableKeys,
  transportKeys,
  bucketKeys,
  ["KeyGroups", "Bedrock", "CloudWatchLogs"],
  {
    asset: {
      dynamo: { default: null },
      sns: { default: null },
      s3: { default: null, Asset: "WRITE", IntakeUploadedFiles: "WRITE" },
      additionalResources: { default: null },
    },
    echo: {
      dynamo: { default: null },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    activityEventQueuer: {
      dynamo: { default: null },
      sns: { default: null, ActivityEvent: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    analyticsEventQueuer: {
      dynamo: { default: null },
      sns: { default: null, EventAnalytics: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    gql: {
      dynamo: { default: "READ" },
      sns: {
        default: null,
        Plan: "PUBLISH",
        QuestionGeneration: "PUBLISH",
        SmokeballIntegration: "PUBLISH",
      },
      s3: {
        default: null,
        IntakeFormSnapshots: "READ",
        IntakeUploadedFiles: "WRITE",
        QuestionGenerationFiles: "WRITE",
      },
      additionalResources: { default: null },
    },
    me: {
      dynamo: { default: null, Team: "READ" },
      sns: { default: null, Plan: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null, KeyGroups: "ACCESS" },
    },

    Backoff: {
      dynamo: { default: null },
      sns: { default: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    Plan: {
      dynamo: { default: "WRITE" },
      sns: { default: "PUBLISH" },
      s3: { default: null, IntakeFormSnapshots: "WRITE" },
      additionalResources: { default: null },
    },
    Requeue: {
      dynamo: { default: null },
      sns: { default: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    Migrate: {
      dynamo: { default: "WRITE" },
      sns: { default: null, Migrate: "PUBLISH" },
      s3: { default: null, IntakeFormSnapshots: "WRITE" },
      additionalResources: { default: null },
    },
    QuestionGeneration: {
      dynamo: { default: "READ", MatterType: "WRITE" },
      sns: { default: null, Backoff: "PUBLISH", Plan: "PUBLISH" },
      s3: {
        default: null,
        QuestionGenerationFiles: "WRITE",
        IntakeUploadedFiles: "READ",
        IntakeFormSnapshots: "READ",
      },
      additionalResources: {
        default: null,
        Bedrock: "ACCESS",
      },
    },
    Translation: {
      dynamo: { default: "READ" },
      sns: { default: null, Backoff: "PUBLISH", Plan: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null, Bedrock: "ACCESS" },
    },
    AutoReminder: {
      dynamo: { default: "READ", Submission: "WRITE", Tracker: "WRITE" },
      sns: { default: null },
      s3: { default: null, IntakeFormSnapshots: "READ" },
      additionalResources: { default: null },
    },
    "data-sync": {
      dynamo: { default: "READ", MatterType: "WRITE" },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    formVersion: {
      dynamo: { default: "READ" },
      sns: { default: null, Plan: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    apiHealthCheck: {
      dynamo: { default: null },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    "reminder-scanner": {
      dynamo: { default: "READ" },
      sns: { default: null, AutoReminder: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    DeadLetterAnalyser: {
      dynamo: { default: null },
      sns: { default: null },
      s3: { default: null },
      additionalResources: {
        default: null,
        Bedrock: "ACCESS",
        CloudWatchLogs: "ACCESS",
      },
    },
  },
);

export const specialPermissions = buildPermissionsDef(
  [
    "Plan",
    "Requeue",
    "Migrate",
    "dead-letter-dequeuer",
    "change-processor",
    "gql",
  ],
  [
    "Audit",
    "DeadLetterItem",
    "Change",
    "Migration",
    "SmokeballCommandResponse",
  ],
  transportKeys,
  [],
  ["SmokeballCommands"],
  {
    Plan: {
      dynamo: { default: null, Audit: "WRITE" },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    Requeue: {
      dynamo: { default: null, DeadLetterItem: "WRITE" },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    Migrate: {
      dynamo: { default: null, Change: "READ", Migration: "WRITE" },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    "dead-letter-dequeuer": {
      dynamo: { default: null, DeadLetterItem: "WRITE" },
      sns: { default: null, DeadLetterAnalyser: "PUBLISH" },
      s3: { default: null },
      additionalResources: { default: null },
    },
    "change-processor": {
      dynamo: { default: null, Change: "WRITE" },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null },
    },
    gql: {
      dynamo: { default: null, SmokeballCommandResponse: "READ" },
      sns: { default: null },
      s3: { default: null },
      additionalResources: { default: null, SmokeballCommands: "ACCESS" },
    },
  },
);
